module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/JfkLeE/tc-custom/9781685502188.jpg?1723405046384",
      "alt": "This image is the cover for the book Red Roses"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Red Roses\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Ward Gabriel was devastated when his husband died unexpectedly, leaving him to care for their young son. Ward didn’t expect to meet Paul, one of the teachers at his son’s school, and the feelings Paul stirred up."), _c('br'), _c('br'), _vm._v("Paul Kowalczyk wasn’t expecting the hot lawyer he met in passing would agree to go on a date. But he does, and as their relationship gets more serious, Paul gives Ward a dozen red roses, not realizing Ward’s husband used to give him roses every week."), _c('br'), _c('br'), _vm._v("When Ward’s son discovers the roses, should he tell his son he’s dating Paul, who isn’t out at school? Will Paul choose his feelings for Ward over his desire to remain closeted at work?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      W.S. Long\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0